import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {EventLight} from '../../../../../../../domain/event/event-light';
import moment from 'moment';
import {EventThemeEnum} from '../../../../../../../domain/agenda/model/constante/event-theme-enum';
import {LinkTypeEnum} from '../../../../../../../domain/agenda/model/link-type.enum';

@Component({
             selector: 'app-widget-event-item',
             templateUrl: './home-dashboard-widget-event-item.component.html',
             styleUrls: ['./home-dashboard-widget-event-item.component.scss']
           })
export class HomeDashboardWidgetEventItemComponent implements OnInit {

  @Output() eventSubscribed: EventEmitter<any> = new EventEmitter<any>();

  @Input() eventDate: string;
  @Input() events: Array<EventLight>;
  @Input() locale: string;

  readonly linkTypeEnum = LinkTypeEnum;

  month: string;
  day: string;

  constructor() {
  }

  ngOnInit(): void {
    this.provideLocaleDateFormat();
  }

  getClassByTheme(event: EventLight): string {
    switch (event.theme) {
      case EventThemeEnum.DEBT:
        return 'border-dette';
      case EventThemeEnum.PROSPECTIVE:
        return 'border-prospective';
      case EventThemeEnum.GUARANTY:
        return 'border-garantie';
      default :
        return undefined;
    }
  }

  getColorByTheme(event: EventLight): string {
    switch (event.theme) {
      case EventThemeEnum.DEBT:
        return 'insito';
      case EventThemeEnum.PROSPECTIVE:
        return 'prospective-background';
      case EventThemeEnum.GUARANTY:
        return 'violet';
      case EventThemeEnum.SUBSIDIES:
        return 'fairways';
      default :
        return 'secondary';
    }
  }

  public hasLinkByType(event: EventLight, linkType: LinkTypeEnum): boolean {
    return event.links.filter(link => link.typeLink === linkType).length > 0;
  }

  public getLinkByType(event: EventLight, linkType: LinkTypeEnum): string {
    return event.links.filter(link => link.typeLink === linkType).shift().link;
  }

  public gotToProgram(event: EventLight): void {
    if (this.hasLinkByType(event, this.linkTypeEnum.PROGRAM_LINK)) {
      window.location.href = this.getLinkByType(event, this.linkTypeEnum.PROGRAM_LINK);
    }
  }

  public onRedirectToEvent(event: EventLight): void {
    this.eventSubscribed.emit(event);
  }

  private provideLocaleDateFormat(): void {
    const monthLowerCase = moment(this.eventDate).locale(this.locale)
                                                 .format('MMM')
                                                 .split('', 3)
                                                 .join('');

    this.month = `${monthLowerCase.charAt(0).toUpperCase().concat(monthLowerCase.slice(1))}`;

    this.day = moment(this.eventDate).locale(this.locale)
                                     .format('D');
  }

}
